module.exports = __webpack_public_path__ + "media/img/frontend_application/christmas/candy-icon-8e46322571bed246cc2fed772f2dc738.png";